import { View } from "extensions/marionette";
import Radio from "backbone.radio";

import { destroyPopovers } from "common/utils";
import { SERIALIZE_DATES_FROM_STORE } from "common/actions/common";

import { Loader } from "common/components/loader";
import { Dialog } from "common/components/dialog/dialog";
import { references } from "common/helpers/references";

import { MerchantPickerFullPageView } from "./merchantPickerFullPageView";
import demoPickerTemplate from "./merchantDemoPicker.jst";

import "./merchantDemoPicker.scss";

const PickerDialog = Dialog.extend({
    dismissable: true,
    backdrop: "static",
    className: "modal fade pz-dialog merchant-picker-dialog"
});

export const merchantDemoPickerFactory = function(opts) {
    const packageName = references.toAlias(opts.packageRef, "package")?.display_name || opts.packageRef;
    
    const DemoPicker = View.extend({
        template: demoPickerTemplate,
        className: "merchant-demo-picker",
        ui: {
            liteButton: "button.lite"
        },
        events: {
            "click .lite": "forceLight",
            "click .pro": "demoPro",
            "click .enterprise": "demoEnterprise",
            "click .all": "demoAll"
        },
        
        showLoader() {
            this.$el.empty().append("<div class='tab-spinner'></div>");
            Loader.addTo(this.$(".tab-spinner"));
        },
    
        demoAll() {
            this.pick("demo_All");
        },
        
        demoPro() {
            if (packageName === "Pro") {
                this.pick("Pro");
            } else {
                this.pick("demo_Pro");
            }
        },
    
        demoEnterprise() {
            if (packageName === "Enterprise") {
                this.pick("Enterprise");
            } else {
                this.pick("demo_Enterprise");
            }
        },
        
        forceLight() {
            if (packageName === "Lite") {
                this.pick("Lite");
            } else {
                this.pick("demo_Lite");
            }
        },
        
        pick(pName) {
            this.showLoader();
            localStorage.setItem("package-override", pName);
            if (typeof opts.success === "function") {
                opts.success(opts.merchantID);
                return;
            }
            window.location.href = `/merchant/dashboard?merchant=${opts.merchantID}&dates=${SERIALIZE_DATES_FROM_STORE().dates}`;
        },
        
        onAttach() {
            this.ui.liteButton.focus();
        },
        
        onDestroy() {
            Loader.removeFrom(this.$(".tab-spinner"));
        },
        
        templateContext() {
            return {
                name: opts.merchantName,
                currentPackageName: packageName,
                isSuper: Radio.channel("main").request("get:user").isSuperUser()
            };
        }
    });
    
    if (opts.fullPage) {
        destroyPopovers();
    
        return new MerchantPickerFullPageView({
            content: new DemoPicker()
        });
    }
    
    return new PickerDialog({
        content: new DemoPicker(),
        render: true
    });
};
